import { render, staticRenderFns } from "./RatingAgency.vue?vue&type=template&id=7ce99216&scoped=true"
import script from "./RatingAgency.vue?vue&type=script&lang=js"
export * from "./RatingAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce99216",
  null
  
)

export default component.exports